import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';
import { IGlobalEmployeeDetailGridDataModel } from '../../../entities-api/IGlobalEmployeeDetailGridDataModel';
import { PageService } from '../../../services/page.service';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { GridResultEnum } from '../../../constants/grid-result.enum';
import { HttpClient } from '@angular/common/http';
import { GridResultService } from '../../../services/gridresult.service';
import { IContainerMappingDetailGridDataModel } from '../../../entities-api/IContainerMappingDetailGridDataModel';
import { IContainerMappingFetchCriteriaModel } from '../../../entities-api/IContainerMappingFetchCriteriaModel';
import { Constants } from '../../../constants/constants';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { IMfModel } from '../../../entities-api/IMfModel';
import { Router } from '@angular/router';
import { ContainermappingService } from '../../../services/containermapping.service';
import * as ExcelJS from 'exceljs';
import { ExportExcelService } from '../../../services/export-excel-service';
@Component({
  selector: 'opm-opm-containermappings',
  templateUrl: './opm-containermappings.component.html',
  styleUrls: ['./opm-containermappings.component.less'],
  standalone: false
})

export class OpmContainermappingsComponent implements OnInit {
  @ViewChild('ngselectmf') ngselectmf: NgSelectComponent;
  constructor(
    protected http: HttpClient,
    private gridtype: GridResultService,
    private page: PageService,
    private router: Router,
    private containermappingService: ContainermappingService,
    private exportexcelService: ExportExcelService) {

  }
  name = 'Angular';
  isLoaded = false;
  isLoaded1 = true;
  isLoaded2 = false;
  environment = [
    { id: 4, name: 'STAGE' },
    { id: 5, name: 'PROD' }
  ];
  geocode = [];
  appcode = [];
  mfcode = [];
  mfcodeobs$: Observable<any[]>;
  gridDataModel: IContainerMappingDetailGridDataModel;
  containerMapingModel: IContainerMappingDetailGridDataModel = {
    ContainerMappingDetails: [],
    TotalCount: 0,
  };
  gridTypeEnum = GridTypeEnum;
  gridResult: string;
  gridResultEnum = GridResultEnum;
  selectedappcode = [];
  selectedgeo;
  selectedmf = [];
  selectedenv;
  appname = [];
  geoname = [];
  mfname = [];
  currentPage: number;
  filter: IContainerMappingFetchCriteriaModel = this.containermappingService.filerconatinermapping;
  noMatchesFoundMsg: string = "No matches Found";
  isUserAuthorized: boolean = false;
  opmUpdatesAvailable: boolean = false;
  visiblNoMatchesFoundPopup: boolean = false;
  totalCount: number;
  isPagingVisible: boolean = false;
  isDEV: boolean = false;
  isSTAGE: boolean = false;
  isQA: boolean = false;
  isLOAD: boolean = false;
  isLoadedgeo: boolean = false;
  renderselect: boolean = false;
  env: string;
  mfmodel: IMfModel = this.containermappingService.mfmodel;
  gname: string;
  exportAllMappings: IContainerMappingDetailGridDataModel;
  ngOnInit() {

    this.containermappingService.getCurrentUserAsync().then(() => {
      this.isUserAuthorized = true;
    },
      () => {
      });

    this.containermappingService.getEnv().then((data) => {
      this.env = data;
      if (data == 'dev') {
        this.selectedenv = { id: 1, name: 'DEV' };
        this.isDEV = true;
      }
      else if (data == 'qa') {
        this.selectedenv = { id: 2, name: 'QA' };
        this.isQA = true;
      }
      else if (data == 'load') {
        this.selectedenv = { id: 3, name: 'LOAD' };
        this.isLOAD = true;
      }
      else {
        this.selectedenv = { id: 5, name: 'PROD' }
        this.isSTAGE = true;
      }
    })
    this.containermappingService.getappcodes().then((data) => {
      for (var i = 0; i < data.Appcode.length; i++) {
        this.appcode[i] = { id: i + 1, name: data.Appcode[i] }
      }
      this.isLoaded = true;
    });



    this.containermappingService.getgeocodes().then((data) => {
      for (var k = 0; k < data.Geocode.length; k++) {
        this.geocode[k] = { id: k + 1, name: data.Geocode[k] }
      }
      this.isLoadedgeo = true;
    });
  }
  loadmf($event) {
    if ($event.length != 0) {

      this.isLoaded1 = false;
      this.mfmodel.geo = $event[0].name.toString();
      this.mfmodel.envid = this.selectedenv.id;
      this.containermappingService.getMfCodes(this.mfmodel).then((data) => {
        for (var j = 0; j < data.Mfcode.length; j++) {
          this.mfcode[j] = data.Mfcode[j];
        }
        this.mfcodeobs$ = of(this.mfcode);
      });
    }
    else {

      this.isLoaded1 = true;
      this.mfcode = [];
      this.mfcodeobs$ = of([]);
      this.ngselectmf.clearModel();

    }
  }
  loadmfforstage($event) {
    if ($event.length != 0) {
      this.isLoaded1 = false;
      this.mfmodel.geo = this.selectedgeo[0].name;
      this.mfmodel.envid = this.selectedenv.id;
      this.containermappingService.getMfCodes(this.mfmodel).then((data) => {
        for (var j = 0; j < data.Mfcode.length; j++) {
          this.mfcode[j] = data.Mfcode[j];
        }
        this.mfcodeobs$ = of(this.mfcode);
      });
    }
    else {

      this.isLoaded1 = true;
      this.mfcode = [];
      this.mfcodeobs$ = of([]);
      this.ngselectmf.clearModel();

    }
  }
  isFormValid(): boolean {
    return !!(this.selectedappcode &&
      this.selectedgeo &&
      this.selectedenv &&
      this.selectedgeo.length != 0 &&
      this.selectedappcode.length != 0);
  }

  async getvalues() {

    this.filter.Env = this.selectedenv.id;
    this.geoname = [];
    this.appname = [];
    for (var i = 0; i < this.selectedappcode.length; i++) {
      this.appname.push(this.selectedappcode[i].name);
    }
    for (var i = 0; i < this.selectedgeo.length; i++) {
      this.geoname.push(this.selectedgeo[i].name);
    }
    if (this.selectedmf.length != 0) {
      for (var i = 0; i < this.selectedmf.length; i++) {
        this.mfname.push(this.selectedmf[i]);
      }
    }
    this.filter.Geo = this.geoname.toString();
    this.filter.Mfcode = this.mfname.toString();
    this.filter.Appcode = this.appname.toString();
    this.appname = [];
    this.geoname = [];
    this.mfname = [];
    this.currentPage = 0;
    this.page.CurrentPageNumber(0);
    this.gridtype.GridresultType(this.gridResultEnum.Containermapping);
    this.gridResult = this.gridtype.gridResult;
    await this.getcontainermappings();
    await this.getFilterContainerMappingsDownloaded();
  }
  async getcontainermappings() {
    await this.containermappingService.getContainermappings(this.currentPage, false).then((data: IContainerMappingDetailGridDataModel) => {
      this.populatecontmapping(data)
    })
  }
  async getAllcontainermappings() {
    this.filter.Env = this.selectedenv.id;
    await this.containermappingService.getAllContainerMappings().then((data: IContainerMappingDetailGridDataModel) => {
      this.exportAllMappings = data;
    })
    this.excelfileCreation(true, this.exportAllMappings);
  }
  async getFilterContainerMappingsDownloaded() {
    await this.containermappingService.getContainermappings(this.currentPage, true).then((data: IContainerMappingDetailGridDataModel) => {
      this.containerMapingModel = data;
    })
  }
  async refreshModel() {
    await this.containermappingService.getContainermappings(this.currentPage, false).then((data: IContainerMappingDetailGridDataModel) => {

      this.gridDataModel = data;
      this.noMatchesFoundMsg = "No matches Found";
      this.visiblNoMatchesFoundPopup = data.ContainerMappingDetails.length === 0;
      this.totalCount = data.TotalCount;
      this.isPagingVisible = data.ContainerMappingDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
    });
  }
  populatecontmapping(data) {
    this.gridDataModel = data;
    this.noMatchesFoundMsg = "No matches Found";
    this.visiblNoMatchesFoundPopup = data.ContainerMappingDetails.length === 0;
    this.totalCount = data.TotalCount;
    this.isPagingVisible = data.ContainerMappingDetails.length !== 0 && this.totalCount > Constants.PagingConst.RecordsPerPage;
  }
  onPageChange(page: number) {
    this.currentPage = page;
    if (this.gridResult == this.gridTypeEnum.Containermapping) {
      this.getcontainermappings();
    }
    else {
      this.refreshModel();
    }
  }
  async excelfileCreation(isExportAllmappingsEnabled, fileData) {
    if (isExportAllmappingsEnabled) {
      fileData = this.exportAllMappings.ContainerMappingDetails;
    } else {
      fileData = fileData;
    }
    const date = new Date().toISOString().slice(0, 10);
    const workBook = new ExcelJS.Workbook();
    const groupdata = fileData.reduce((acc, row) => {
      const envid = Number(row.EnvironmentId);
      (acc[envid] ||= []).push(row)
      return acc;
    }, {} as { [key: number]: any[] });
    const unique = [...new Set(fileData.filter(row => row.EnvironmentId))];
    const headers = this.exportexcelService.getModifiedHeader(fileData, true, false);
    if (unique.length > 1) {
      (Object.entries(groupdata) as [string, any[]][]).forEach(([envId, rows], index) => {
        let sheetName = "";
        if (envId == "4") {
          sheetName = "Stage";
        }
        else if (envId == "5") {
          sheetName = "Prod";
        }
        else if (envId == "6") {
          sheetName = "BCP";
        }
        else {
          sheetName = 'Container Mapping';
        }
        const sheet = workBook.addWorksheet(sheetName);
        sheet.columns = headers;
        sheet.addRows(rows);
        sheet.eachRow((row, rowIndex) => {
          row.eachCell((cell, colIndex) => {
            if (cell.value != null && cell.value != undefined) {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              };
              if (rowIndex == 1) {
                cell.font = { bold: true, size: 14 };
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFDDDDDD' },
                }
              }
            }
          })
        });
      });
      const buffer = await workBook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `A&A People Feed ApplicationContainerMapping_${date}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
  routeToBaseMapping() {
    this.router.navigate(['/basemappings/'], {
      skipLocationChange: true,
    });
  }
  routeToAppView() {
    this.router.navigate(['/onboardedapps/'], {
      skipLocationChange: true,
    });
  }
}

